import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

import RefreshIcon from "@material-ui/icons/Refresh";

import { useStyles } from "./AdminPageTitle.css";
import { withRouter } from "react-router";

class AdminPageTitle extends Component {
  render() {
    const { classes, title, refreshUrl } = this.props;
    return (
      <div className={classes.root}>
        <div style={{ fontSize: 24, fontWeight: "bold" }}>{title}</div>
        {this.props.refreshUrl && (
          <Tooltip
            arrow
            title="Refresh"
            className={classes.tooltip}
            onClick={() => this.props.history.push(refreshUrl)}
          >
            <RefreshIcon />
          </Tooltip>
        )}
      </div>
    );
  }
}

export default withStyles(useStyles)(withRouter(AdminPageTitle));
